// removed by extract-text-webpack-plugin
module.exports = {"user-rankings":"user-rankings__2F4Uz","sortable":"sortable__tKbdC","sort-control":"sort-control__3Jgz0","desc":"desc__3l5AE","asc":"asc__k4R8C"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/UserRankings/styles.scss
// module id = ./app/scripts/views/App/views/UserRankings/styles.scss
// module chunks = 1